import { Info } from "lucide-react";

export default function AdminHint({ children, className = "" }) {
  return (
    <div className={`flex items-start gap-3 rounded-2xl border border-brand-line bg-brand-lavender-soft/40 px-4 py-3 mb-6 ${className}`}>
      <Info size={16} strokeWidth={1.5} className="text-brand-lavender-dark shrink-0 mt-0.5" />
      <p className="font-body text-sm text-brand-slate leading-relaxed">{children}</p>
    </div>
  );
}
